import logo from '../../assets/images/logo.png';
import facebook from '../../assets/images/facebook.svg';
import instagram from '../../assets/images/instagram.svg';
import twitter from '../../assets/images/twitter.svg';
import linkedin from '../../assets/images/linkedin.svg';

const Footer = () => {
  return (
    <>
      <div className='footer'>
        <div className='footer__list'>
          <div className='footer__list__single'>
            <img src={logo} alt='' className='footer-logo' />
          </div>

          <div className='footer__list__single'>
            <h2>We are social</h2>

            <div className='footer__list__single__links socials'>
              <a
                href={' https://facebook.com/PlbyEdves/'}
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src={facebook} alt='facebook' />
              </a>
              <a
                href={'https://www.instagram.com/plbyedves/'}
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src={instagram} alt='instagram' />
              </a>
              <a
                href={'https://twitter.com/EdvesSuite'}
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src={twitter} alt='twitter' />
              </a>
              <a
                href={' https://www.linkedin.com/company/edvessuite/mycompany/'}
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src={linkedin} alt='linkedin' />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className='copyright-text'>
        <p style={{ margin: '0 auto' }}>
          Copyright © 2022EDVES Inc. All rights reserved.
        </p>
      </div>
    </>
  );
};

export default Footer;
